module.exports = __webpack_public_path__ + "img/1.ab8ed7eb.png";